import { all, fork } from 'redux-saga/effects';

//Layout
import LayoutSaga from './layout/saga';
import dashboardSaga from './dashboard/saga';

//Login
import authSaga from './auth/login/saga';

//Brand
import brandSaga from './brand/saga';

//Register
import registerSaga from './auth/register/saga';

//User Profile
import ProfileSaga from './auth/profile/saga';

// Forget Password
import forgetPasswordSaga from './auth/forgetpwd/saga';
import traceabilitiesSaga from './traceabilities/saga';
import clientSaga from './client/sagas';
import apiListSaga from './apiList/saga';

//Invoices
import invoiceSaga from './invoices/saga';
import dashboardPWSaga from './dashboardPW/saga';

//ITEM DEFINITONS
import ItemDefSaga from './itemDefinitions/saga';
import InactiveUserSaga from './inactiveUsers/saga';
import salesOrdersSaga from './salesOrders/saga';

import wharehouseReceiptSaga from './warehouseReceipts/saga';
import cargoReleaseSaga from './cargoRelease/saga';
import purchaseOrdersSaga from './purchaseOrders/saga';
import POcomparisonSaga from './POcomparison/saga';
import EntitiesSaga from './Entities/saga';

// Table Views
import tableViewsSaga from './tableViews/saga';
import milestoneSaga from './milestones/sagas';

import CommoditySaga from './Commodity/saga';
import SavedSearchesSaga from './SavedSearches/saga';

import PermissionsSaga from './Permissions/sagas';
import TasksSaga from './Tasks/sagas';
import RolesSaga from './Roles/sagas';
import UsersSaga from './Users/sagas';
import ConfigTaskSaga from './ConfigTasks/sagas';
import SyncConfiguration from './syncConfig/saga';
import ShipmentsSaga from './shipments/saga';
import PickupOrdersSaga from './pickupOrders/sagas';
import LoadFilesSagas from './LoadFiles/sagas';
import SummaryImportSaga from './summaryImport/saga';
import dashboardHLSaga from './dashboardHl/saga';
import AttachmentsSaga from './attachments/sagas';
import cargoReleaseCreationSaga from './cargoReleaseCreation/saga';
import RegistrySetRequest from './RegistrySetRequest/saga';
import DocumentsSaga from './documents/sagas';
import ConfigPODSaga from './configReportPOD/sagas';
import invoicesListSaga from './invoicesList/saga';
import chargesListSaga from './ChargesList/saga';

//INACTIVE USERS
export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    fork(dashboardSaga),
    fork(dashboardPWSaga),

    fork(authSaga),
    fork(brandSaga),
    fork(registerSaga),
    fork(ProfileSaga),
    fork(forgetPasswordSaga),
    fork(traceabilitiesSaga),
    fork(clientSaga),
    fork(apiListSaga),
    fork(invoiceSaga),

    fork(ItemDefSaga),
    fork(InactiveUserSaga),

    fork(salesOrdersSaga),
    fork(ShipmentsSaga),
    fork(purchaseOrdersSaga),
    fork(PickupOrdersSaga),
    fork(wharehouseReceiptSaga),
    fork(cargoReleaseSaga),
    fork(POcomparisonSaga),
    fork(EntitiesSaga),
    fork(invoicesListSaga),

    fork(tableViewsSaga),
    fork(milestoneSaga),
    fork(CommoditySaga),
    fork(SavedSearchesSaga),
    fork(PermissionsSaga),
    fork(TasksSaga),
    fork(RolesSaga),
    fork(UsersSaga),
    fork(ConfigTaskSaga),
    fork(SyncConfiguration),
    fork(LoadFilesSagas),
    fork(SummaryImportSaga),
    fork(dashboardHLSaga),
    fork(AttachmentsSaga),
    fork(cargoReleaseCreationSaga),
    fork(RegistrySetRequest),
    fork(DocumentsSaga),
    fork(ConfigPODSaga),
    fork(chargesListSaga),
  ]);
}
